var map = {
	"./base-menu.svg": 3027,
	"./capacity-menu.svg": 1514,
	"./dashboard-menu.svg": 4942,
	"./data-menu.svg": 8222,
	"./faq-menu.svg": 8350,
	"./hidden-vin.svg": 6966,
	"./lang.svg": 1610,
	"./loading.svg": 5698,
	"./manage-menu.svg": 5321,
	"./mint-product.svg": 4624,
	"./offline-capacity.svg": 3876,
	"./online-capacity.svg": 147,
	"./processing-capacity.svg": 9496,
	"./quality-menu.svg": 3091,
	"./show-vin.svg": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5270;